export default IconTemperatureFahrenheit => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-temperature-fahrenheit" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
  <path d="M13 12l5 0" />
  <path d="M20 6h-6a1 1 0 0 0 -1 1v11" />
</svg>`;